import { Icon, Typography, Image } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Card, Section } from '@hero/atoms';
import { DetailItem } from '@hero/molecules';
import { getAverageTimeFromSeconds } from '@hero/utils';

import * as S from './style';

function AutomationRecipientEngagement({ analytics }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const averageAcceptanceRate = getAverageTimeFromSeconds(analytics?.avgAcceptanceTimeInSeconds);

  return (
    <Card style={{ gap: 24, flex: 1 }}>
      <Typography variant="body1Bold">{t('recipientEngagement')}</Typography>
      <S.InfoCardsWrapper>
        <Card style={{ borderColor: 'var(--color-accent-primary-default)' }}>
          <S.CardHeader>
            <S.IconWrapper>
              <Icon name="email" color="var(--color-accent-primary-default)" size="lg" />
            </S.IconWrapper>
            <Typography variant="subtitle4Bold" emphasis="weak">
              {t('giftsSent')}
            </Typography>
          </S.CardHeader>
          <Typography variant="subtitle1Bold">{analytics?.acceptanceRates?.total}</Typography>
        </Card>
        <Card style={{ borderColor: 'var(--color-accent-primary-strongest)' }}>
          <S.CardHeader>
            <S.IconWrapper>
              <Icon name="giftbox-opened" color="var(--color-accent-primary-strongest)" size="lg" />
            </S.IconWrapper>
            <Typography variant="subtitle4Bold" emphasis="weak">
              {t('giftsOpened')}
            </Typography>
          </S.CardHeader>
          <Typography variant="subtitle1Bold">{analytics?.acceptanceRates?.opened}</Typography>
        </Card>
        <Card style={{ borderColor: 'var(--color-info-default)' }}>
          <S.CardHeader>
            <S.IconWrapper>
              <Icon name="gift-box" color="var(--color-info-default)" size="lg" />
            </S.IconWrapper>
            <Typography variant="subtitle4Bold" emphasis="weak">
              {t('giftsUnopened')}
            </Typography>
          </S.CardHeader>
          <Typography variant="subtitle1Bold">{analytics?.acceptanceRates?.unopened}</Typography>
        </Card>
      </S.InfoCardsWrapper>
      <Section
        style={{ border: '1px solid var(--color-accent-secondary-weaker)', padding: '16px' }}
      >
        <S.SpeedArea>
          <Typography variant="subtitle1Bold" color="success">
            90.37%
          </Typography>
          <Typography variant="body2" emphasis="weaker">
            {t('averageAcceptanceRateDesc')}
          </Typography>
          <Image
            src={theme.images.speedDialPrimary}
            height="36px"
            alt={t('dashboardSpeedDialTitle')}
          />
        </S.SpeedArea>
      </Section>
      <DetailItem title={`${t('avgAcceptanceTime')}:`}>
        {averageAcceptanceRate ? (
          <Typography variant="body2Bold" style={{ textAlign: 'right' }}>
            <Icon name="clock" />
            {averageAcceptanceRate}
          </Typography>
        ) : (
          <Typography variant="body2Bold" style={{ textAlign: 'right' }}>
            {t('notAcceptedYet')}
          </Typography>
        )}
      </DetailItem>
    </Card>
  );
}

export { AutomationRecipientEngagement };
